/** #773 — User transport commands win over background reconcile for a short window. */
import { diagnosticLog } from '../utils/diagnosticLogger';

export const USER_TRANSPORT_COMMAND_WINDOW_MS = 3_000;

let lastUserTransportCommandAt = 0;
let lastUserTransportCommandKindValue: string | null = null;

export function resetTransportUserCommandForTests(): void {
  lastUserTransportCommandAt = 0;
  lastUserTransportCommandKindValue = null;
}

export function markUserTransportCommand(kind: string): void {
  lastUserTransportCommandAt = Date.now();
  lastUserTransportCommandKindValue = kind;
}

export function msSinceUserTransportCommand(): number {
  if (lastUserTransportCommandAt <= 0) return Number.POSITIVE_INFINITY;
  return Date.now() - lastUserTransportCommandAt;
}

export function isWithinUserTransportCommandWindow(
  windowMs = USER_TRANSPORT_COMMAND_WINDOW_MS,
): boolean {
  return msSinceUserTransportCommand() < windowMs;
}

export function getLastUserTransportCommandKind(): string | null {
  return lastUserTransportCommandKindValue;
}

export function beaconTransportFlap(detail: {
  from: string;
  to: string;
  source: string;
  rendererState?: string;
}): void {
  diagnosticLog('warn', 'playback', 'transport_flap', detail);
}

/** Returns true when reconcile must not flip playbackState — user command wins. */
export function shouldBlockReconcilePlaybackFlip(
  localState: string,
  targetState: string,
  source: string,
  rendererState?: string,
): boolean {
  if (localState === targetState) return false;
  if (!isWithinUserTransportCommandWindow()) return false;
  beaconTransportFlap({ from: localState, to: targetState, source, rendererState });
  return true;
}
